import { NiIcon } from "@/ni-ui"

export default {
  name: "env-item",
  components:{
    NiIcon,
  },

  props:{
    env_code: {
      type: String,
      default: "",
    },

    env_text: {
      type: String,
      default: "",
    },

  },


  data(){
    return{
      env: {
        default: {
          icon: "#the_third_iconhuanjing_png",
          icon_style: {
            height: "1rem",
            width: "1rem",
          }
        },

        3: {    // 生产
          icon: "#the_third_iconhuanjing-copy",
        },
        4: {    // 开发
          icon: "#the_third_iconhuanjing-copy-copy",
        },
        // 5:{
        //   icon: "#the_third_iconhuanjing_png",
        // },
        // 6:{
        //   icon: "#the_third_iconhuanjing_png",
        // },
        // 7:{
        //   icon: "#the_third_iconhuanjing_png",
        // },
        // 8:{
        //   icon: "#the_third_iconhuanjing_png",
        // },
        // 9:{
        //   icon: "#the_third_iconhuanjing_png",
        // },
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/omnis-business/env-item/env-item.js